import React from "react";
import { Modal } from "react-bootstrap";

interface SuccessFailureModalProps {
  onClose: () => void;
  shouldShow: boolean;
  data: { type?: string; point?: number; message?: string };
  openQrscannerModal: () => void;
}

export default function SuccessFailureModal({
  onClose,
  shouldShow,
  data,
  openQrscannerModal,
}: SuccessFailureModalProps) {
  return (
    <React.Fragment>
      {/* <Modal
        show={shouldShow}
        backdrop="static"
        keyboard={false}
        className="dark-modal"
        centered
        contentClassName="custom-modal"
      >
        <Modal.Body bsPrefix={"main-container"}>
          <div className="modal-body success-fail">
            <img src={"/images/" + data?.type + ".png"} />
            <h4 className="rider-name-content">{data?.message}</h4>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrap mb-3">
            <button
              type="button"
              className="rkmd-btn btn-lg btn-black ripple-effect w-100 mt-3"
              onClick={() => onClose()}
            >
              {"Close"}
            </button>
          </div>
        </Modal.Footer>
      </Modal> */}
      {data?.type == "success" ? (
        <Modal
          show={shouldShow}
          backdrop="static"
          keyboard={false}
          className="dark-modal"
          centered
          contentClassName="custom-modal star-points-earned-modal modal-bg-white"
        >
          <Modal.Header>
            <button type="button" className="btn-close" onClick={() => onClose()} />
          </Modal.Header>
          <Modal.Body>
            <div className="star-points-earned-body d-flex flex-column justify-content-center align-items-center gap-4">
              <div className="star-icon">
                <img src="/images/star-icons.png" />
              </div>
              <h6>Points Earned</h6>
              <div className="star-points-earned-text">
                <p className="d-flex align-items-center">
                  You earned{" "}
                  <span className="d-inline-flex gap-1 mx-2">
                    <img src="/images/star-circle.svg" width={24} />
                    <strong>{data?.point}</strong>
                  </span>{" "}
                  Points
                </p>
              </div>
              <div className="star-points-note-text">
                <p>Scan and earn more points to get position in Progress Board</p>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      ) : (
        <Modal
          show={shouldShow}
          backdrop="static"
          keyboard={false}
          className="dark-modal"
          centered
          contentClassName="custom-modal scan-failed-modal modal-bg-white"
        >
          <Modal.Header>
            <button type="button" className="btn-close" onClick={() => onClose()} />
          </Modal.Header>
          <Modal.Body>
            <div className="scan-failed-body d-flex flex-column justify-content-center align-items-center gap-4">
              <div className="qr-code-fail-icon">
                <img src="/images/qr-code.svg" alt="" />
              </div>
              <div className="qr-code-fail-msg d-flex align-items-center gap-3">
                <div className="qr-code-small-icon">
                  <img src="/images/qr-code-small.svg" alt="" />
                </div>
                <div className="flex-grow-1">
                  <h6>QR Code Scan Failed</h6>
                  <p>{data?.message}</p>
                </div>
              </div>
              <button
                className="btn btn-danger re-scan-btn w-100 btn-lg"
                onClick={() => {
                  onClose();
                  openQrscannerModal();
                }}
              >
                Scan
              </button>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </React.Fragment>
  );
}
